

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import store from '@/store/store';

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [

        {
            // =============================================================================
            // MAIN LAYOUT ROUTES
            // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // =============================================================================
                // Theme Routes
                // =============================================================================
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/admin/home/'),
                    meta: {
                        auth: true,
                        pageTitle: 'Dashboard',
                    }
                },
                {
                    path: '/credit-cards/view-cards',
                    name: 'view-cards',
                    component: () => import('./views/admin/credit-cards/view-cards/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'View Cards', active: true },
                        ],
                        pageTitle: 'Credit Cards',
                        auth: true
                    },
                },
                {
                    path: '/credit-cards/view-cards/v2',
                    name: 'view-cards-v2',
                    component: () => import('./views/admin/credit-cards/view-cards-v2/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'View Cards', active: true },
                        ],
                        pageTitle: 'Credit Cards',
                        auth: true
                    },
                },
                {
                    path: '/credit-cards/issuers/v2',
                    name: 'issuers-v2',
                    component: () => import('./views/admin/credit-cards/issuers-v2/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'View Issuers', active: true },
                        ],
                        pageTitle: 'Issuers',
                        auth: true
                    },
                },
                {
                    path: '/credit-cards/pending-approvals',
                    name: 'pending-approvals',
                    component: () => import('./views/admin/credit-cards/pending-approvals/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pending Approval', active: true },
                        ],
                        pageTitle: 'Pending Approvals',

                        auth: true
                    },
                },
                {
                    path: '/credit-cards/offers',
                    name: 'offers',
                    component: () => import('./views/admin/credit-cards/offers/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Offers', active: true },
                        ],
                        pageTitle: 'Offers',

                        auth: true
                    },
                },
                {
                    path: '/offers/offer-details',
                    name: 'offer-details',
                    component: () => import('./views/admin/credit-cards/offer-details/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Offers', url: '/credit-cards/offers' },

                            { title: 'Offer Details', active: true },
                        ],
                        pageTitle: 'Offers',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (to.params.data != undefined && to.params.data._id == undefined) {
                            next('/credit-cards/offers/')
                        }
                        next()
                    },
                    props: true

                },

                {
                    path: '/offers/add-offer',
                    name: 'add-offer',
                    component: () => import('./views/admin/credit-cards/offer-details/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Offers', url: '/credit-cards/offers' },

                            { title: 'Add Offer', active: true },
                        ],
                        pageTitle: 'Offers',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (to.params == undefined) {
                            next('/credit-cards/offers/')
                        }
                        next()
                    },
                    props: true

                },
                {
                    path: '/credit-cards/point-categories',
                    name: 'point-categories',
                    component: () => import('./views/admin/credit-cards/point-categories/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Point Groups', active: true },
                        ],
                        pageTitle: 'Point Groups',

                        auth: true
                    },
                },
                {
                    path: '/point-categories/subcategories/:id',
                    name: 'subcategories',
                    component: () => import('./views/admin/credit-cards/subcategories/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Point Groups', url: '/credit-cards/point-categories' },
                            { title: 'Manage Subcategories', active: true },
                        ],
                        pageTitle: 'Point Groups',

                        auth: true
                    },
                },
                {
                    path: '/credit-cards/cheatsheet',
                    name: 'cheatsheet',
                    component: () => import('./views/admin/credit-cards/cheatsheet-issuers/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cheat Sheet', active: true },
                        ],
                        pageTitle: 'Cheat Sheet',

                        auth: true
                    },
                },
                {
                    path: '/cheatsheet/excludecards/:id',
                    name: 'excludecards',
                    component: () => import('./views/admin/credit-cards/cheatsheet-removecards/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Cheat Sheet', url: '/credit-cards/cheatsheet' },
                            { title: 'Exclude Credit Cards', active: true },
                        ],
                        pageTitle: 'Cheat Sheet',

                        auth: true
                    },
                },
                {
                    path: '/credit-cards/bonuscategories',
                    name: 'bonuscategories',
                    component: () => import('./views/admin/credit-cards/bonuscategories/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Custom Bonus Categories', active: true },
                        ],
                        pageTitle: 'Bonus Categories',

                        auth: true
                    },
                },
                {
                    path: '/promos',
                    name: 'promos',
                    component: () => import('./views/admin/credit-cards/promos/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Promos', active: true },
                        ],
                        pageTitle: 'Promos',

                        auth: true
                    },
                },
                {
                    path: '/useraddedpromos',
                    name: 'userAddedPromos',
                    component: () => import('./views/admin/credit-cards/user-promos/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'User Added Promos', active: true },
                        ],
                        pageTitle: 'Promos',

                        auth: true
                    },
                    props: true
                },
                {
                    path: '/promos/userpromo-details',
                    name: 'userpromo-details',
                    component: () => import('./views/admin/credit-cards/promo-details/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'User Added Promos', url: '/useraddedpromos' },

                            { title: 'Promo Details', active: true },
                        ],
                        pageTitle: 'Promos',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (to.params.data != undefined && to.params.data._id == undefined) {
                            next('/promos/')
                        }
                        next()
                    },
                    props: true

                },
                {
                    path: '/promos/promo-details',
                    name: 'promo-details',
                    component: () => import('./views/admin/credit-cards/promo-details/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Promos', url: '/promos' },

                            { title: 'Promo Details', active: true },
                        ],
                        pageTitle: 'Promos',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (to.params.data != undefined && to.params.data._id == undefined) {
                            next('/promos/')
                        }
                        next()
                    },
                    props: true

                },

                {
                    path: '/promos/add-promo',
                    name: 'add-promo',
                    component: () => import('./views/admin/credit-cards/promo-details/index.vue'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Promos', url: '/promos' },

                            { title: 'Add Promo', active: true },
                        ],
                        pageTitle: 'Promos',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (to.params == undefined) {
                            next('/promos/')
                        }
                        next()
                    },
                    props: true

                },
                {
                    path: '/view-cards/add-card',
                    name: 'add card',
                    component: () => import('./views/admin/card-actions/add-card/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'View Cards', url: '/credit-cards/view-cards' },
                            { title: 'Add Card', active: true },
                        ],
                        pageTitle: 'Add Card',

                        auth: true
                    },
                },
                {
                    path: '/view-cards/edit-card',
                    name: 'edit-card',
                    component: () => import('./views/admin/card-actions/edit-card/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'View Cards', url: '/credit-cards/view-cards' },
                            { title: 'Edit Card', active: true },
                        ],
                        pageTitle: 'Edit Card',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (!to.params.card.name) {
                            next('/credit-cards/view-cards/')
                        }
                        next()
                    },
                    props: true
                },
                {
                    path: '/view-cards/review-card',
                    name: 'review-card',
                    component: () => import('./views/admin/card-actions/review-card/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Pending Approval', url: '/credit-cards/pending-approvals' },
                            { title: 'View Pending Approval', active: true },
                        ],
                        pageTitle: 'Review Pending Approval',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (!to.params.cardName || !to.params.issuerName) {
                            next('/credit-cards/pending-approvals')
                        }
                        next()
                    },
                    props: true
                },
                {
                    path: '/accounts',
                    name: 'accounts',
                    component: () => import('./views/admin/accounts/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Users', active: true },
                        ],
                        pageTitle: 'Users',

                        auth: true
                    },
                },
                {
                    path: '/accounts/profiles',
                    name: 'profiles',
                    component: () => import('./views/admin/accounts/Profiles'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Users', url: '/accounts' },
                            { title: 'Profiles', url: '/accounts/profiles', active: true },
                        ],
                        pageTitle: 'Profiles',

                        auth: true
                    },
                    beforeEnter: (to, from, next) => {
                        if (!to.params._id || !to.params.firstname || !to.params.lastname) {
                            next('/accounts')
                        }
                        next()
                    },
                    props: true
                },
                {
                    path: '/messages',
                    name: 'messages',
                    component: () => import('./views/admin/messages/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Messages', active: true },
                        ],
                        pageTitle: 'Messages',

                        auth: true
                    },
                },
                {
                    path: '/manage-admins',
                    name: 'manage admins',
                    component: () => import('./views/admin/manage-admins/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Manage Admins', active: true },
                        ],
                        pageTitle: 'Manage Admins',

                        auth: true
                    }, beforeEnter: (to, from, next) => {
                        if (store.state.userType != 'superAdmin') {
                            next('/')
                        }
                        next()
                    },
                },
                {
                    path: '/settings',
                    name: 'settings',
                    component: () => import('./views/admin/settings/'),
                    meta: {
                        breadcrumb: [
                            { title: 'Home', url: '/' },
                            { title: 'Settings', active: true },
                        ],
                        pageTitle: 'Settings',

                        auth: true
                    },
                },
            ],
        },
        // =============================================================================
        // FULL PAGE LAYOUTS
        // =============================================================================
        {
            path: '',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                // =============================================================================
                // PAGES
                // =============================================================================
                {
                    path: '/admin/login',
                    name: 'admin-login',
                    component: () => import('@/views/admin/auth'),
                    meta: { auth: false }
                },
                {
                    path: '/admin/forgot-password',
                    name: 'forgot-password',
                    component: () => import('@/views/admin/auth/forgot-password/'),
                    meta: { auth: false }
                },
                {
                    path: '/admin/reset/:token',
                    name: 'reset-password',
                    component: () => import('@/views/admin/auth/reset-password/'),
                    meta: { auth: false }
                },
                {
                    path: '/user/login',
                    name: 'user-login',
                    component: () => import('@/views/user/auth')
                },
                {
                    path: '/user/register',
                    name: 'user-register',
                    component: () => import('@/views/user/register')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () => import('@/views/admin/Error404.vue')
                },
            ]
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

// router.beforeEach((to, from, next) => {
// //     Vue.auth.token('token',Vue.localStorage.get('token'))
//     console.log(Vue.auth.check())
// })

export default router

